<template>
  <div class="promo-design-group">
    <v-checkbox
      v-model="actions.rf_retention_countdown_enabled"
      label="Enable countdown timer"
      trueValue="true"
      falseValue="false"
      hideDetails
    />
    <div class="mt-4 flex flex-col gap-4">
      <div class="promo-fonts-size-input gap-2">
        <v-menu
          v-model="menuEndDate"
          :closeOnContentClick="false"
          transition="scale-transition"
          offsetY
          :disabled="disabled"
          class="flex-1"
          minWidth="290px"
        >
          <template #activator="{ props }">
            <v-text-field
              appendInnerIcon="md:event"
              readonly
              v-bind="props"
              persistentPlaceholder
              :disabled="disabled"
              variant="outlined"
              density="compact"
              :modelValue="dayjs(endDate).format('MMM Do, YYYY')"
              label="End on"
              hideDetails
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDateComputed"
            hideHeader
            :min="dayjs().format('YYYY-MM-DD')"
            @update:modelValue="menuEndDate = false"
          ></v-date-picker>
        </v-menu>
        <RfTimePicker
          ref="endTimePicker"
          :initTime="endTime"
          :disabled="disabled"
          class="flex-1"
          autoWidth
          sameWidth
          @updateTime="time => (endTime = StringUtils.hhmmBy30MinIntervalIndex(time))"
        />
      </div>

      <v-text-field
        v-model.trim="
          (currentTranslations.hasOwnProperty('rf_retention_countdown_start_caption')
            ? previewActions
            : actions
          ).rf_retention_countdown_start_caption
        "
        variant="outlined"
        density="compact"
        label="Caption"
        persistentPlaceholder
        maxlength="50"
        counter="50"
        :disabled="currentTranslations.hasOwnProperty('rf_retention_countdown_start_caption')"
        placeholder="Offer ends in"
      ></v-text-field>
      <div class="promo-window-size-inputs -mt-4">
        <v-select
          v-model="actions.rf_retention_countdown_size"
          :items="[
            { value: 'small', text: 'Small' },
            { value: 'medium', text: 'Medium' },
            { value: 'large', text: 'Large' },
          ]"
          itemTitle="text"
          label="Size"
          variant="outlined"
          required
          density="compact"
          hideDetails
        ></v-select>
        <v-select
          v-model="actions.rf_retention_countdown_position"
          :items="[
            { value: 'top', text: 'Top' },
            { value: 'bottom', text: 'Bottom' },
          ]"
          itemTitle="text"
          label="Position"
          variant="outlined"
          required
          density="compact"
          hideDetails
        ></v-select>
      </div>
    </div>
  </div>
</template>

<script>
import RfTimePicker from "@/components/RfTimePicker.vue";
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import StringUtils from "@/utils/StringUtils";
import dayjs from "dayjs";
import { ref } from "vue";

export default {
  name: "RfRetentionActionsCountdown",
  components: { RfTimePicker },
  mixins: [LanguagePreviewMixin],
  props: ["app", "actions", "model", "disabled"],
  setup: () => ({ dayjs, StringUtils, endTimePicker: ref() }),
  data() {
    return {
      menuEndDate: false,
      endDate: null,
      endTime: null,
    };
  },
  computed: {
    endDateTime() {
      if (!this.endDate || !this.endTime) return null;
      return dayjs(`${this.endDate} ${this.endTime}`, "YYYY-MM-DD hh:mm").toISOString();
    },
    endDateComputed: {
      get() {
        return this.endDate;
      },
      set(value) {
        this.endDate = `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`;
      },
    },
  },
  watch: {
    endDateTime(v) {
      this.actions.rf_retention_countdown_end_datetime = v;
    },
  },
  mounted() {
    const now = this.roundToNearestMinutes(dayjs());
    if (!this.actions.rf_retention_countdown_end_datetime) {
      const future = now.add(48, "hours");
      this.endDate = future.format("YYYY-MM-DD");
      this.endTime = future.format("hh:mm");
    } else {
      const date = dayjs(this.actions.rf_retention_countdown_end_datetime);
      this.endDate = date.format("YYYY-MM-DD");
      this.endTime = date.format("hh:mm");
    }
    this.endTimePicker.time = StringUtils.intervalIndexByHhmm(this.endTime);
  },
  methods: {
    roundToNearestMinutes(time, roundValue = 30) {
      const mod = time.minute() % roundValue;
      const timeCopy =
        mod < roundValue / 2
          ? time.subtract(mod, "minutes")
          : time.add(roundValue - mod, "minutes");
      return timeCopy.startOf("minute");
    },
  },
};
</script>

<style lang="scss" scoped></style>
